import React from "react";
import { usePageInvoiceViewHook } from "./invoice-view-hooks";

type PageContextInvoiceView = ReturnType<typeof usePageInvoiceViewHook>;
export const InvoiceViewContext =
  React.createContext<PageContextInvoiceView | null>(null);

export function usePageContextInvoiceView() {
  const context = React.useContext(InvoiceViewContext);

  if (!context) {
    throw new Error(
      "usePageContextInvoiceView must be used within a PageContextInvoiceViewProvider",
    );
  }

  return context;
}
